module.exports = __webpack_public_path__ + "static/2-291ec430375d8618b1bec328242f6806.jpg";